import React from 'react';
import PropTypes from 'prop-types';

export default function QuestionMark({ opacity, showTitle }) {
	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="svg question-mark"
		>
			{showTitle && <title>question icon</title>}
			{opacity ? (
				<g
					opacity="0.75"
					clipPath="url(#clip0_2037_34139)"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M8 2.13333C4.75993 2.13333 2.13333 4.75993 2.13333 8C2.13333 11.2401 4.75993 13.8667 8 13.8667C11.2401 13.8667 13.8667 11.2401 13.8667 8C13.8667 4.75993 11.2401 2.13333 8 2.13333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
						fill="white"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M7.74279 7.28499C7.31616 7.36524 6.93337 7.43725 6.93337 8.00001V8.88534C6.89658 9.21497 7.05172 9.53656 7.33262 9.71292C7.61351 9.88929 7.97057 9.88929 8.25146 9.71292C8.53236 9.53656 8.6875 9.21497 8.65071 8.88534V8.66134C9.79596 8.5433 10.6409 7.53782 10.56 6.38934C10.5478 5.69518 10.2482 5.03718 9.73265 4.57217C9.2171 4.10717 8.53179 3.87682 7.84004 3.93601C6.74137 3.93601 5.32271 4.64001 5.32271 5.88801C5.31658 6.33354 5.66681 6.70269 6.11204 6.72001C6.54332 6.72001 6.7316 6.48461 6.92472 6.24315C7.12805 5.98894 7.33675 5.72801 7.84004 5.72801C8.04098 5.71637 8.23828 5.78519 8.38838 5.91929C8.53849 6.05338 8.62904 6.2417 8.64004 6.44268C8.64004 6.94401 8.24537 7.18934 7.79737 7.27468C7.77912 7.27815 7.76092 7.28158 7.74279 7.28499ZM8.74671 11.1787C8.74671 10.6485 8.3169 10.2187 7.78671 10.2187H7.80804C7.5506 10.2158 7.30257 10.3154 7.11853 10.4954C6.93449 10.6754 6.82952 10.9212 6.82671 11.1787C6.82671 11.7089 7.25651 12.1387 7.78671 12.1387C8.3169 12.1387 8.74671 11.7089 8.74671 11.1787Z"
						fill="white"
					/>
				</g>
			) : (
				<g
					fill="none"
					fillRule="evenodd"
				>
					<path d="M0 0h16v16H0z" />
					<circle
						cx="8"
						cy="8"
						r="7"
						strokeWidth="2"
						stroke="currentColor"
					/>
					<path
						fill="currentColor"
						d="M7.139 10.531h1.746v1.694H7.139V10.53zM5 6.312c.047-1.113.436-1.902 1.166-2.367.461-.297 1.027-.445 1.7-.445.882 0 1.615.21 2.2.633.583.422.875 1.047.875 1.875 0 .508-.127.935-.38 1.283-.149.211-.434.48-.856.809l-.416.322a1.26 1.26 0 0 0-.451.615c-.047.149-.072.379-.076.692H7.18c.023-.66.086-1.117.187-1.369.102-.252.363-.542.785-.87l.428-.334c.14-.105.254-.22.34-.345.156-.215.234-.452.234-.71 0-.296-.087-.567-.26-.811-.174-.244-.492-.366-.953-.366-.453 0-.774.15-.963.451-.19.3-.285.613-.285.938H5z"
					/>
				</g>
			)}
		</svg>
	);
}

QuestionMark.propTypes = {
	opacity: PropTypes.bool,
	showTitle: PropTypes.bool,
};
